import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useOWASContext } from '@/views/ListReport/Report/Owas/context';
import { useGetOwasLoad } from '@/views/ListReport/Report/Owas/hooks/useGetOwasLoad';
import { CustomFormItem } from '../../styles';
import { CustomSelect } from '../styles';

interface LoadProps {
	formName: string[];
}

export function Load({ formName }: Readonly<LoadProps>): JSX.Element {
	const { parameters } = useOWASContext();

	const { isLoading, data, isError } = useGetOwasLoad({
		organization_id: parameters?.organization_id,
		company_id: parameters?.company_id
	});

	return (
		<Row>
			<Col span={24}>
				<CustomFormItem
					labelCol={{ span: 24 }}
					label={I18n.get('Load')}
					name={[...formName, 'load']}
					rules={[{ required: true, message: I18n.get('Select the load') }]}
				>
					<CustomSelect
						options={data}
						loading={isLoading}
						placeholder={I18n.get('Load')}
						disabled={isLoading || isError}
					/>
				</CustomFormItem>
			</Col>
		</Row>
	);
}
